'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = CustomAction;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _panelsUi = require('panels-ui');

var _browserVendorPrefix = require('browser-vendor-prefix');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function CustomAction(props) {
  var actionStyle = _extends({}, style.base, props.style);

  return _react2['default'].createElement(
    _panelsUi.Action,
    { href: props.href, style: actionStyle, activeStyle: style.active, hoverStyle: style.active },
    props.children
  );
}

var style = {
  active: {
    paddingLeft: 15
  },
  base: _extends({}, _browserVendorPrefix.alignSelfStretch, {
    borderBottomWidth: 1,
    borderStyle: 'solid',
    paddingTop: 15,
    paddingBottom: 15,
    textTransform: 'uppercase',
    transition: 'padding-left 0.25s linear'
  })
};
module.exports = exports['default'];